module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/leather@2x_b890a9.jpg";